'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEHeader = undefined;

var _map = require('ramda/src/map');

var _map2 = _interopRequireDefault(_map);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _core = require('@blueprintjs/core');

var _ = require('../../');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Wrapper = _glamorous2.default.div({
  background: _.Colors.GREY1,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center'
}, function (_ref) {
  var isRtl = _ref.isRtl,
      isNarrow = _ref.isNarrow;
  return {
    flexDirection: isRtl ? 'row-reverse' : 'row',
    padding: '2px ' + (isNarrow ? '2px' : _.Layout.PADDING)
  };
});

var Logo = _glamorous2.default.img({
  maxHeight: 45
});

var StyledButton = (0, _glamorous2.default)(_core.Button)({
  background: 'none !important',
  height: 36
}, function (_ref2) {
  var active = _ref2.active;
  return {
    color: (active ? _.Colors.BLUE1 : _.Colors.GREY2) + ' !important'
  };
});

var DEHeader = exports.DEHeader = function DEHeader(_ref3) {
  var availableLocales = _ref3.availableLocales,
      locale = _ref3.locale,
      changeLocale = _ref3.changeLocale,
      isRtl = _ref3.isRtl,
      logo = _ref3.logo,
      LabelRenderer = _ref3.LabelRenderer,
      isNarrow = _ref3.isNarrow;
  return _react2.default.createElement(
    Wrapper,
    { isRtl: isRtl, isNarrow: isNarrow },
    _react2.default.createElement(Logo, { src: logo, alt: 'logo' }),
    _react2.default.createElement(
      _core.ButtonGroup,
      { minimal: true },
      (0, _map2.default)(function (l) {
        return _react2.default.createElement(
          StyledButton,
          { key: l, active: l === locale, onClick: function onClick() {
              return changeLocale(l);
            } },
          _react2.default.createElement(LabelRenderer, { id: l })
        );
      })(availableLocales)
    )
  );
};

DEHeader.propTypes = {
  availableLocales: _propTypes2.default.array,
  locale: _propTypes2.default.string,
  changeLocale: _propTypes2.default.func.isRequired,
  isRtl: _propTypes2.default.bool,
  isNarrow: _propTypes2.default.bool,
  logo: _propTypes2.default.string,
  LabelRenderer: _propTypes2.default.func
};


//////////////////
// WEBPACK FOOTER
// ./~/oecd-visions/build/components/de-header/index.js
// module id = 2015
// module chunks = 0